import React from "react";
import "./Experience.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { IoSchoolOutline } from "react-icons/io5";
import { MdWorkOutline } from "react-icons/md";

function Experience() {
  return (
    <section id="experience">
      <h5>What Background I Have</h5>
      <h2>My Experience</h2>
      <div className="container experience__container">
        <VerticalTimeline
          lineColor="var(--color-light)"
          className="experience__timeline"
        >
          <VerticalTimelineElement
            contentArrowStyle={{
              borderRight: "7px solid var(--color-bg-variant)",
            }}
            contentStyle={{ background: "var(--color-bg-variant)" }}
            className="vertical-timeline-element--work"
            date="March 2023 - Present"
            iconStyle={{
              background: "var(--color-bg-variant)",
              color: "var(--color-primary)",
            }}
            icon={<MdWorkOutline />}
          >
            <h3 className="vertical-timeline-element-title">
              Frontend Developer Intern - SQLI
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Oujda, Maroc</h4>
            <p></p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentArrowStyle={{
              borderRight: "7px solid var(--color-bg-variant)",
            }}
            contentStyle={{ background: "var(--color-bg-variant)" }}
            className="vertical-timeline-element--work"
            date="2018 - 2023"
            iconStyle={{
              background: "var(--color-bg-variant)",
              color: "var(--color-primary)",
            }}
            icon={<IoSchoolOutline />}
          >
            <h3 className="vertical-timeline-element-title">
              National School of Applied Sciences
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Oujda, Maroc</h4>
            <p>Computer engineering</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentArrowStyle={{
              borderRight: "7px solid var(--color-bg-variant)",
            }}
            contentStyle={{ background: "var(--color-bg-variant)" }}
            className="vertical-timeline-element--work"
            date="July 2022 - September 2022"
            iconStyle={{
              background: "var(--color-bg-variant)",
              color: "var(--color-primary)",
            }}
            icon={<MdWorkOutline />}
          >
            <h3 className="vertical-timeline-element-title">
              Full-Stack Developer Intern - SQLI
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Oujda, Maroc</h4>
            <p>SQLI Customers Portal: Devoloped an App for Dynamics 365</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentArrowStyle={{
              borderRight: "7px solid var(--color-bg-variant)",
            }}
            contentStyle={{ background: "var(--color-bg-variant)" }}
            className="vertical-timeline-element--work"
            date="July 2021 - August 2021"
            iconStyle={{
              background: "var(--color-bg-variant)",
              color: "var(--color-primary)",
            }}
            icon={<MdWorkOutline />}
          >
            <h3 className="vertical-timeline-element-title">
              Full-Stack Developer Intern - CCIS
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Nador, Maroc</h4>
            <p>Developed an employee management system website</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentArrowStyle={{
              borderRight: "7px solid var(--color-bg-variant)",
            }}
            contentStyle={{ background: "var(--color-bg-variant)" }}
            className="vertical-timeline-element--work"
            date="2016 - 2017"
            iconStyle={{
              background: "var(--color-bg-variant)",
              color: "var(--color-primary)",
            }}
            icon={<IoSchoolOutline />}
          >
            <h3 className="vertical-timeline-element-title">
              Taha Hussein High school
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Nador, Maroc</h4>
            <p>Bachelor of Physical Science</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </section>
  );
}

export default Experience;
